import { render, staticRenderFns } from "./AdmissionList.vue?vue&type=template&id=3d82a387&"
import script from "./AdmissionList.vue?vue&type=script&lang=js&"
export * from "./AdmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports